import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge, Popover } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import notification from '../../Actions/notification';
import  ListNotification  from '../Notification/NotificationList';
import BannerControl from '../BannerControl';
const { getNotifications, seenNotification } = notification.actions;


class Notification extends Component {
    constructor(props) {
        super(props);
        this.handleClickMoreNotifications = this.handleClickMoreNotifications.bind(this);
    }
    componentDidMount() {
        this.props.getNotifications(this.props.notificationsPagination);
        this.interval = setInterval(() => this.props.getNotifications(this.props.notificationsPagination), 350000)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    } 
	
    render() {
        return (
            <span className='header-option notification'>
                <Popover
                    overlayClassName='notification-content'
                    placement="bottomRight"
                    content={
                        <ListNotification 
                            notifications={this.props.notifications} 
                            pagination={this.props.notificationsPagination}
                            handleClickNotification={this.handleClickNotification.bind(this)}
                            handleClickMore={this.handleClickMoreNotifications}
                            isLoading={this.props.isNotificationsLoading}
                        />
                    } 
                    trigger="click">
                    <Badge count={this.props.notifications.filter(x => x.seen === 0).length} dot >
                        <BellOutlined className='notification-icon'/>
                    </Badge>
                </Popover>
                <BannerControl/>
                
            </span>
        );
    }

    handleClickNotification(item) {
        if (item.seen === 0) {
            this.props.seenNotification(item.idNotification, this.props.notificationsPagination);
        } 
    }
    
    handleClickMoreNotifications() {
        let query = {
            ...this.props.notificationsPagination,
            perPage: this.props.notificationsPagination.perPage + 5
        }
        this.props.getNotifications(query);
	}
    
}

const mapStateToProps = state => {
	return {
        notifications: state.notification.notifications,
        notificationsPagination: state.notification.notificationsPagination,
        isNotificationsLoading: state.notification.isNotificationsLoading,
	};
};

const mapDispatchToProps = dispatch => {
    return {
        getNotifications(query) {
        	dispatch(getNotifications(query))
        },
        seenNotification(notificationId, pagination) {
            dispatch(seenNotification(notificationId, pagination))
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Notification);